export default __webpack_public_path__ + "static/media/maximise_Icon.ce8621ed.svg";